import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TabsComponent, SaveButton } from '../../common';
import ModifyAboutComponent from './modify-about';
import ModifyDemographicsComponent from './modify-demographics';
import ModifyTouchpointComponent from './modify-touchpoint';
import { IntakeFormValidation, validationConstants } from '../validate-intake-form';
import './modify-intake-form.scss';
import * as intakeFormConstants from './intake-form-constants';

export class ModifyIntakeForm extends Component {

  onPreview() {
    const { onPreview } = this.props;
    onPreview();
  }

  onSaveForm() {
    const { onSave } = this.props;
    onSave();
  }

  onCancelHandler() {
    const { onCancel } = this.props;
    onCancel();
  }

  sectionHasErrors(section) {
    const { intakeValidationResult  } = this.props;
    var sectionErrors = intakeValidationResult && intakeValidationResult.validationErrors.filter(error => error.section === section);
    return !!sectionErrors && sectionErrors.length > 0;
  }

  render() {
    const { title, match, isSubmitting, intakeValidationResult, loadingValidation, validationErr  } = this.props;
    const { path, url } = match || {};
    const iconClass = "glyphicon glyphicon-exclamation-sign notification-icon";
    const aboutHasErrors = this.sectionHasErrors(validationConstants.aboutSection);
    const demoHasErrors = this.sectionHasErrors(validationConstants.demographicsSection);
    const touchpointHasErrors = this.sectionHasErrors(validationConstants.touchpointSection);
    const routes = [
      {
        label: 'ABOUT',
        notificationIcon: aboutHasErrors ? <span className={iconClass}/> : null,
        description: aboutHasErrors ? 'has errors' : '',
        url,
        path,
        exact: true,
        render: () => <ModifyAboutComponent {...this.props}/>,
      },
      {
        label: 'DEMOGRAPHICS',
        notificationIcon: demoHasErrors ? <span className={iconClass}/> : null,
        description: demoHasErrors ? 'has errors' : '',
        url: url + '/demographics',
        path: path + '/demographics',
        render: () => <ModifyDemographicsComponent {...this.props}/>,
      },
      {
        label: 'TOUCHPOINT',
        notificationIcon: touchpointHasErrors ? <span className={iconClass}/> : null,
        description: touchpointHasErrors ? 'has errors' : '',
        url: url + '/touchpoint',
        path: path + '/touchpoint',
        render: () => <ModifyTouchpointComponent {...this.props}/>,
      }
    ];

    return (
      <div id="modify-intake-form">
        <h1>{title}</h1>
        <IntakeFormValidation
          validationResult={intakeValidationResult}
          excludedSections={[
            validationConstants.aboutSection,
            validationConstants.demographicsSection,
            validationConstants.touchpointSection,
          ]}
          loadingErrorCondition={"Cannot edit form."}
          loadingErrorInstructions={"Try refreshing or re-opening the form. If the issue persists, contact technical support."}
          loadingErr={validationErr}/>
        <TabsComponent id="modify-intake-form" routes={routes}/>
        <div className="actions">
          <button id="preview" className="btn btn-primary" type="button" onClick={e => this.onPreview()}>
            Preview Form
          </button>
          <SaveButton
            id="save"
            text={"Save"}
            saving={isSubmitting}
            disabled={loadingValidation || this.sectionHasErrors(validationConstants.loadingSection)}
            savingText={'Saving...'}
            onSave={e => this.onSaveForm()}/>
          <button id="cancel" className="btn btn-default" type="button" onClick={e => this.onCancelHandler()}>
            Cancel
          </button>
        </div>
      </div>
    );
  }
}

ModifyIntakeForm.propTypes = {
  title: PropTypes.string,
  match: PropTypes.object,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onPreview: PropTypes.func,
  isSubmitting: PropTypes.bool,
  siteId: PropTypes.string,
  programId: PropTypes.string,
  value : PropTypes.object,
  selectedTouchpointId: PropTypes.string,
  defaultValue : PropTypes.object,

  intakeValidationResult : PropTypes.object,
  loadingValidation : PropTypes.bool,
  validationErr : PropTypes.object,

  updateValue : PropTypes.func,
  updateOrder: PropTypes.func,
  updateTouchpoint: PropTypes.func,
  disabled : PropTypes.bool,
  errors: PropTypes.array,
  showErrors: PropTypes.bool,

  formMode: PropTypes.oneOf(intakeFormConstants.editStatus),
};

export default ModifyIntakeForm;
